export default __webpack_public_path__ + "static/media/services.575417ef.png";